import { useEffect, useRef } from 'react';

import { logError } from 'shared-services/logger-service';

const DocListeners = ({ eventEmitter, applyStoreAction, currentUserId }) => {
    const currentUserIdRef = useRef(currentUserId);

    useEffect(() => {
        currentUserIdRef.current = currentUserId;
    }, [currentUserId]);

    const listen = () => {
        eventEmitter.on('document_created', doc => {
            if (doc.members.some(user => user.id === currentUserIdRef.current)) {
                applyStoreAction({
                    type: 'DOC_ADD_SOCKET',
                    payload: { doc }
                });
            }
        });

        eventEmitter.on('document_archived', ({ id: docId }) => {
            applyStoreAction({
                type: 'DOC_ARCHIVE_SOCKET',
                payload: { docId }
            });
        });

        eventEmitter.on('document_unarchived', ({ id: docId }) => {
            applyStoreAction({
                type: 'DOC_UNARCHIVE_SOCKET',
                payload: { docId }
            });
        });

        eventEmitter.on('doc_change_error', ({ id: docId, error }) => {
            logError('doc', new Error('doc change error'), { error });

            applyStoreAction({
                type: 'DOC_UPDATE_SOCKET',
                payload: {
                    docId,
                    doc: {
                        applyError: true
                    }
                }
            });
        });

        eventEmitter.on('document_edited', doc => {
            if (doc.members.some(user => user.id === currentUserIdRef.current)) {
                applyStoreAction({
                    type: 'DOC_UPDATE_SOCKET',
                    payload: {
                        docId: doc.id,
                        doc
                    }
                });
            } else {
                applyStoreAction({
                    type: 'DOC_REMOVE_SOCKET',
                    payload: { docId: doc.id }
                });
            }
        });

        eventEmitter.on('document_removed', doc => {
            applyStoreAction({
                type: 'DOC_REMOVE_SOCKET',
                payload: { docId: doc.id }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default DocListeners;
